import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';


function GrantReturnCashReceipt(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};
	const upperCase = {
			"textTransform" : "uppercase"
	};
	
	const isGrantCash = props.grantCashData? true: false;
	const opData = isGrantCash? props.grantCashData : props.returnCashData;
	const operationTitle = isGrantCash? getLabel('retail.grant_cash.title') : getLabel('retail.return_cash.title');
	const amount = getCurrencyValue(opData.operationAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const terminalBalance = getCurrencyValue(opData.object.terminalBalance, conf.cs.m, conf.cs.nd, conf.cs.ct);
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			
			<div>{getLabel('retail.date_time') + ": " + getFormattedTimestamp()}</div>
			<div>{getLabel('retail.terminal_balance') + ": " + terminalBalance}</div>
			<div>{getLabel('retail.terminal_number') + ": " + opData.object.idTag}</div>
			<div>{getLabel('retail.operator') + ": " + opData.object.operatorUsername}</div>
			<hr className="hr-line" />
			<div>
				{getLabel('retail.amount')} : {amount}
			</div>
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default GrantReturnCashReceipt;